export default {"src":"https://cdn.jetlend.ru/_next/static/media/google-play-icon.9598fa87.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};